module.exports = __webpack_public_path__ + "media/images/windows_banner@3x-2311c56e3fc5df23e994ef855fb15850.png";